import axios from "axios";
export const state = {
    summaries: [],
    expenses: [],
    expense_report: [],
    alerts: {},
    filter_status: false,
};
export const getters = {
    Summary: state => state.summaries,
    StockAlerts: state => state.alerts,
    filterStatus: state => state.filter_status,

};

export const mutations = {
    SET_SUMMARY(state, newValue) {
        state.summaries = newValue
    },
    SET_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_ALERTS(state, newValue) {
        state.alerts = newValue
    },

};

export const actions = {
    fetchSummary({ commit }, payload) {
        commit('SET_STATUS', true)
        axios.post('dashboard_summary', payload).then(ec_res => {
            commit('SET_STATUS', false)
            commit('SET_SUMMARY', ec_res.data)
        })
    },

    checkExpiry({ commit }) {
        // commit('SET_STATUS', true);
        axios.get(`check_expiry`).then((response) => {
            if (response.status == 200) {
                // let message = { 'msg': response.data.message }
                // dispatch('notification/error', message, { root: true })
                commit('SET_ALERTS', response.data);


            } else {
                // let message = { 'msg': `Payment updated successfully` }
                // dispatch('notification/success', message, { root: true })

            }
        }).catch(() => {
            // commit('SET_STATUS', false)
            // let message = { 'msg': "Error in deleting Payment" }
            // dispatch('notification/error', message, { root: true })
        })
    },


};